import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { message } from "antd";
import i18n from "../../translations/i18";
import { toAddShop } from "../actions/service.actions";
import { toGetMyCart, toDeleteMyCart, toSaveMyCart } from "../actions/cart.actions";
import { consumeCartAddedFeedbackSignal, cancelCartAddedFeedback, publishCartAddedResult } from "../../utils/cartAddedFeedback";
import { getCartErrorMessage } from "../../utils/cartResponse";
import { entityIdsEqual } from "../slices/utils";

const cartSyncMiddleware = createListenerMiddleware();

cartSyncMiddleware.startListening({
  actionCreator: toSaveMyCart.fulfilled,
  effect: (action, api) => {
    if (!(api.getState() as { global: { cartReady: boolean } }).global.cartReady) return;
    const item = action.meta.arg.feedbackItem;
    const requestedFeedback = consumeCartAddedFeedbackSignal();
    if (!item && !requestedFeedback) return;
    // A successful HTTP request alone does not prove the requested line was saved.
    const lines = item?.type === "service" ? action.payload?.services : action.payload?.products;
    const accepted = !item || lines?.some(line => entityIdsEqual(line.id, item.id));
    publishCartAddedResult(Boolean(accepted), item);
    if (accepted) void message.success({ key: "cart-feedback", content: i18n.t("services.productCard.added"), duration: 3 });
    else void message.error({ key: "cart-feedback", content: i18n.t("services.productCard.addFailed"), duration: 5 });
  },
});

cartSyncMiddleware.startListening({
  matcher: isAnyOf(toSaveMyCart.rejected, toDeleteMyCart.rejected, toGetMyCart.rejected, toAddShop.rejected),
  effect: action => {
    cancelCartAddedFeedback();
    publishCartAddedResult(false, toSaveMyCart.rejected.match(action) ? action.meta.arg.feedbackItem : undefined);
    void message.error({ key: "cart-feedback",
      content: getCartErrorMessage(action.payload) || i18n.t("services.productCard.addFailed"), duration: 5 });
  },
});

export default cartSyncMiddleware;
